import React from 'react';
import ReportPageShell from './shared/ReportPageShell';

const SalesByProductGroupReport: React.FC = () => (
  <ReportPageShell
    reportType="sales-by-product-group"
    title="Sales by Product Group"
    subtitle="Net, tax, gross, quantity, and discounts rolled up per product group. Persisted line values — no rate × amount recalculation."
    maxRangeDays={366}
    bullets={[
      'Product Group',
      'Quantity (net of line refunds)',
      'Net',
      'Tax',
      'Gross',
      'Discounts',
    ]}
  />
);

export default SalesByProductGroupReport;
